document.addEventListener('DOMContentLoaded', () => {
  const sizeInputs = document.querySelectorAll('[data-size-input]');
  const sizeOutput = document.querySelector('[data-selected-size]');
  if (sizeInputs.length && sizeOutput) {
    sizeInputs.forEach(input => {
      input.addEventListener('change', () => {
        sizeOutput.textContent = input.value;
      });
    });
  }
});
